import * as React from 'react';
export var AccordionContext = React.createContext({});